import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {injectIntl} from 'react-intl';

import {toggleShowDescriptionCover} from "../../actions/actionFunctions";
import {wizardGroupInterface} from "../../interfaces/wizardItemInterface";
import {useIsMounted, usePrevious} from "../../misc/helperHooks";
import {getFeatureGroupDescription} from "../look/grohe/groheNavigation/groheFunctions";

let timeoutId = 0;

const SelectionDescriptionCover = (props) => {

  const {activePart, wizardGroup, intl, showDescriptionCover, toggleShowDescriptionCover, windowWidth,
    fabricatorData} = props;

  const isMounted = useIsMounted();
  const prevWizardGroup = usePrevious(wizardGroup);
  const prevActivePart = usePrevious(activePart);
  const [coverText, setCoverText] = useState("");

  const getDescriptionText = () => {
    if (wizardGroup && wizardGroup.description) {
      return wizardGroup.description
    }
    if (!activePart) {
      return ""
    }
    return getFeatureGroupDescription(activePart.part, intl, fabricatorData)
  };

  const showCover = () => {
    clearTimeout(timeoutId);
    toggleShowDescriptionCover(false);
    timeoutId = setTimeout(() => {
      const descText = getDescriptionText();
      if (isMounted() && descText) {
        setCoverText(descText);
        toggleShowDescriptionCover(true);
      }
    }, 2000);
  }

  useEffect(() => {
    if (!prevWizardGroup && wizardGroup || (prevWizardGroup && wizardGroup && (prevWizardGroup.id !== wizardGroup.id))) {
      showCover();
    } else if (!prevActivePart && activePart || (prevActivePart && activePart && (prevActivePart.part.partName !== activePart.part.partName))) {
      showCover();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePart, wizardGroup]);

  let styles = {};
  if (coverText && (coverText.length > 250) && (windowWidth < 991)) {
    styles = windowWidth < 640
      ? {fontSize: "10px"}
      : windowWidth < 800 ? {fontSize: "13px"} : {}
  }

  return (
    <div className={"cover" + (showDescriptionCover ? " cover--active" : "")} style={styles}>
      {coverText}
      <button className="ui-close" onClick={() => toggleShowDescriptionCover(false)}/>
    </div>
  )
}

SelectionDescriptionCover.propTypes = {
  activePart: PropTypes.object,
  wizardGroup: PropTypes.shape(wizardGroupInterface),
};

const mapStateToProps = (store) => {
  return {
    showDescriptionCover: store.selectionState.showDescriptionCover,
    windowWidth: store.serverState.windowWidth,
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {
  toggleShowDescriptionCover
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SelectionDescriptionCover)
)
